const PERFIL_CORRETOR_PARCEIRO = 8;

const STATUS_TRATATIVA = {
  1: {
    labelAnalista: "Cotação",
    labelCorretor: "Em Análise",
    cor: "magenta",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  2: {
    labelAnalista: "Proposta",
    labelCorretor: "Proposta",
    cor: "",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  3: {
    labelAnalista: "Emitida",
    labelCorretor: "Emitida",
    cor: "",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  4: {
    labelAnalista: "Apólice Aprovada",
    labelCorretor: "Apólice Aprovada",
    cor: "",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  5: {
    labelAnalista: "Apólice Reprovada",
    labelCorretor: "Apólice Reprovada",
    cor: "",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  6: {
    labelAnalista: "Recusada",
    labelCorretor: "Recusada",
    cor: "vermelho",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  7: {
    labelAnalista: "Apólice cancelada",
    labelCorretor: "Apólice cancelada",
    cor: "",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  8: {
    labelAnalista: "Pendente",
    labelCorretor: "Solicitada",
    cor: "amarelo",
    corCorretor: "azul",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  9: {
    labelAnalista: "Em Processamento",
    labelCorretor: "Em Processamento",
    cor: "",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  10: {
    labelAnalista: "Expirada",
    labelCorretor: "Expirada",
    cor: "",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: false,
  },
  12: {
    labelAnalista: "Apólice Vencida",
    labelCorretor: "Apólice Vencida",
    cor: "",
    permiteEscrita: false,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  13: {
    labelAnalista: "Liberada",
    labelCorretor: "Liberada",
    cor: "azul",
    permiteEscrita: true,
    trocaStatusPerfis: [PERFIL_CORRETOR_PARCEIRO],
    exibeIcone: true,
  },
  14: {
    labelAnalista: "Aceita",
    labelCorretor: "Aceita",
    cor: "verde",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  15: {
    labelAnalista: "Contestada",
    labelCorretor: "Contestada",
    cor: "laranja",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  16: {
    labelAnalista: "Declinada",
    labelCorretor: "Declinada",
    cor: "vermelho",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
  17: {
    labelAnalista: "Transmitida",
    labelCorretor: "Transmitida",
    cor: "cinza",
    permiteEscrita: true,
    trocaStatusPerfis: [],
    exibeIcone: true,
  },
};

const STATUS_COM_JUSTIFICATIVA = [6, 15, 16];

function definicao(idStatus) {
  return STATUS_TRATATIVA[idStatus] || null;
}

function ehCorretor(idPerfil) {
  return idPerfil === PERFIL_CORRETOR_PARCEIRO;
}

function rotuloStatus(idStatus, idPerfil) {
  const status = definicao(idStatus);
  if (!status) return "";
  return ehCorretor(idPerfil) ? status.labelCorretor : status.labelAnalista;
}

function corStatus(idStatus, idPerfil) {
  const status = definicao(idStatus);
  if (!status) return "";
  if (ehCorretor(idPerfil) && status.corCorretor) return status.corCorretor;
  return status.cor;
}

function permiteEscrita(idStatus) {
  const status = definicao(idStatus);
  return status ? status.permiteEscrita : false;
}

function permiteTrocaStatus(idStatus, idPerfil) {
  const status = definicao(idStatus);
  if (!status || !status.permiteEscrita) return false;
  return status.trocaStatusPerfis.indexOf(idPerfil) !== -1;
}

function exibeIconeChat(idStatus) {
  const status = definicao(idStatus);
  return status ? status.exibeIcone : false;
}

function notificacaoChat(resumo) {
  const qtd = resumo ? Number(resumo.qtdNaoLidas) || 0 : 0;
  if (qtd > 0) {
    return { tipo: "ativa", rotulo: qtd > 9 ? "9+" : String(qtd) };
  }
  if (resumo && resumo.notificacaoInformativa) {
    return { tipo: "informativa", rotulo: "-" };
  }
  return { tipo: "nenhuma", rotulo: "" };
}

function mensagemObrigatoria(idStatus) {
  return STATUS_COM_JUSTIFICATIVA.indexOf(idStatus) !== -1;
}

export {
  STATUS_TRATATIVA,
  STATUS_COM_JUSTIFICATIVA,
  PERFIL_CORRETOR_PARCEIRO,
  rotuloStatus,
  corStatus,
  permiteEscrita,
  permiteTrocaStatus,
  exibeIconeChat,
  mensagemObrigatoria,
  notificacaoChat,
};

export default {
  STATUS_TRATATIVA,
  STATUS_COM_JUSTIFICATIVA,
  PERFIL_CORRETOR_PARCEIRO,
  rotuloStatus,
  corStatus,
  permiteEscrita,
  permiteTrocaStatus,
  exibeIconeChat,
  mensagemObrigatoria,
  notificacaoChat,
};



// WEBPACK FOOTER //
// ./src/helpers/status-tratativa.js